import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import InlineSvg from "vue-inline-svg";
import { Position, PositionType } from "@/types";
import { PropType, computed } from "vue";


const __default__ = {
  name: "Tooltip",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  position: {
    type: String as PropType<PositionType>,
    default: Position.TOP,
  },
  minWidth: {
    type: String,
    default: "160px",
  },
  shouldShowTooltip: {
    type: Boolean,
    default: false,
  },
  targetElement: {
    type: Object as PropType<HTMLElement>,
  },
},
  emits: ["onClickCloseTooltip"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "5b29ac6e-topPxStr": (topPxStr.value),
  "5b29ac6e-leftPxStr": (leftPxStr.value),
  "5b29ac6e-widthPxStr": (widthPxStr.value),
  "5b29ac6e-bottomPxStr": (bottomPxStr.value),
  "5b29ac6e-heightPxStr": (heightPxStr.value),
  "5b29ac6e-rightPxStr": (rightPxStr.value),
  "5b29ac6e-minWidth": (__props.minWidth)
}))

const props = __props;

const emit = __emit;

const onClickCloseTooltip = () => {
  emit("onClickCloseTooltip");
};

const targetPosition = computed(() =>
  props.targetElement?.getBoundingClientRect()
);
const widthPxStr = computed(() => `${props.targetElement?.offsetWidth ?? 0}px`);
const heightPxStr = computed(
  () => `${props.targetElement?.offsetHeight ?? 0}px`
);

const topPxStr = computed(() => `${targetPosition.value?.top ?? 0}px`);
const bottomPxStr = computed(() => `${targetPosition.value?.bottom ?? 0}px`);
const leftPxStr = computed(() => `${targetPosition.value?.left ?? 0}px`);
const rightPxStr = computed(() => `${targetPosition.value?.right ?? 0}px`);

const __returned__ = { props, emit, onClickCloseTooltip, targetPosition, widthPxStr, heightPxStr, topPxStr, bottomPxStr, leftPxStr, rightPxStr, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})